import React from "react";
import WeekTemplate from "../components/WeekTemplate";

const WeekTemplatePage = () => {
    return <div>
        <WeekTemplate></WeekTemplate>
    </div>;
    };

export default WeekTemplatePage;